import { render } from "./ThemeToggle.vue?vue&type=template&id=0470848e"
import script from "./ThemeToggle.vue?vue&type=script&lang=js"
export * from "./ThemeToggle.vue?vue&type=script&lang=js"

import "./ThemeToggle.vue?vue&type=style&index=0&id=0470848e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__